import { Model } from "services/models/model";
import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";

export class ApprovalScopeItemActionDocumentMockupModel extends Model implements IModel<ApprovalScopeItemActionDocumentMockupModel> {
  approvalScopeItemActionId: string = "";
  occurrenceType: number = 0;
  documentMockupId: string = "";

  static create(input: any): ApprovalScopeItemActionDocumentMockupModel {
    const model = ObjectMapper.deserialize<ApprovalScopeItemActionDocumentMockupModel>(
      ApprovalScopeItemActionDocumentMockupModel,
      input
    );

    const rawOccurrenceType = input?.occurrenceType ?? input?.OccurrenceType ?? model.occurrenceType;
    model.occurrenceType = rawOccurrenceType != null && rawOccurrenceType !== ''
      ? Number(rawOccurrenceType)
      : 0;
    model.documentMockupId = `${input?.documentMockupId ?? input?.DocumentMockupId ?? model.documentMockupId ?? ''}`;
    model.approvalScopeItemActionId = `${input?.approvalScopeItemActionId ?? input?.ApprovalScopeItemActionId ?? model.approvalScopeItemActionId ?? ''}`;

    return model;
  }
}
